import React from 'react';
import sanitizer from '../../../utils/sanitizer';
import { Root, P } from '../styles';
const Other = (props) => {
  return (
    <Root>
      <P
        dir={props.dir}
        dangerouslySetInnerHTML={{
          __html: sanitizer(
            props.text.android.other.location || `BLOCKED Android Other`
          ),
        }}
      ></P>
    </Root>
  );
};
export default Other;
